const colorsDefault = {
  labelColor: '#B3B3B3',
  lineColor: '#EAECEE',
  pointHoverColor: 'rgb(230, 110, 0)',
  makerColor: '#E66400',
  makerFillColor: '#FFFFFF',
  seriesColor: '#009AD9',
  adgroupCurrentPointColor: '#606060',
  markerPointColor: '#aaff99',
};

const colorsCampaign = {
  labelColor: '#333',
  lineColor: '#EAECEE',
  pointHoverColor: 'rgb(230, 110, 0)',
  makerColor: '#0178d6',
  makerFillColor: '#FFFFFF',
  seriesColor: '#0178d6',
  campaignCurrentPointColor: '#606060',
  markerPointColor: '#aaff99',
  crosshairsColor: '#E66400',
};

function getAdgroupCurrentPointSetting() {
  return {
    color: colorsDefault.markerPointColor,
    marker: {
      enable: true,
      symbol: 'circle',
      radius: 4.5,
      lineWidth: 1,
      lineColor: colorsDefault.adgroupCurrentPointColor,
      fillColor: colorsDefault.adgroupCurrentPointColor,
    },
  };
}

function axisValueFormater(value, clickGraph, i18n) {
  if (value) {
    return clickGraph ?
      i18n.formatDecimalToInteger(value) :
      i18n.formatDecimalToFixed(value);
  }
  return '';
}

function getSlideChartOptions(clickGraph, i18n, coloroptions) {
  const colors = coloroptions || colorsDefault;
  return {
    series: { animation: false },
    chart: {
      type: 'line',
      animation: false,
    },
    title: { text: null },
    xAxis: {
      allowDecimals: !clickGraph,
      labels: {
        enabled: true,
        align: 'left',
        y: 20,
        style: {
          color: colors.labelColor,
          fontWeight: 'bold',
          fontSize: '12px',
        },
        formatter() {
          return axisValueFormater(this.value, clickGraph, i18n);
        },
      },
      title: { text: null },
      categories: null,
      showGridlines: true,
      gridLineWidth: 1,
      gridLineColor: colors.lineColor,
      lineWidth: 1,
      lineColor: colors.lineColor,
      startOnTick: true,
      endOnTick: true,
      tickPositioner() {
        const positions = [];
        let tick = this.dataMin;
        const increment = (this.dataMax - this.dataMin) / 3;

        positions.push(this.dataMin); // eslint-disable-line
        for (let i = 1; i <= 2; i += 1) {
          tick += increment;
          positions.push(clickGraph ? Math.ceil(tick) : Math.ceil(tick * 100) / 100);
        }

        positions.push(clickGraph ? Math.ceil(this.dataMax) : Math.ceil(this.dataMax * 100) / 100); // eslint-disable-line
        return positions;
      },
    },
    yAxis: {
      allowDecimals: true,
      opposite: true,
      title: { text: null },
      tickPositioner() {
        const positions = [];
        const increment = (this.dataMax - this.dataMin) / 2;

        positions.push(this.dataMin); // eslint-disable-line

        positions.push(this.dataMin + increment); // eslint-disable-line
        positions.push(this.dataMax - 0.01); // eslint-disable-line
        return positions;
      },
      labels: {
        enabled: true,
        step: 2,
        formatter() {
          return axisValueFormater(this.value, false, i18n);
        },
        style: {
          color: colors.labelColor,
          fontWeight: 'bold',
          fontSize: '12px',
        },
        align: 'left',
      },
      showGridlines: true,
      gridLineWidth: 1,
      gridLineColor: colors.lineColor,
      lineWidth: 1,
      lineColor: colors.lineColor,
      startOnTick: true,
      endOnTick: false,
    },
    legend: { enabled: false },
    credits: { enabled: false }, // //get rid of hightcharts.com
    tooltip: {
      enabled: false,
      crosshairs: {
        enabled: true,
        color: '#E66400',
        dashStyle: 'longdash',
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false,
        },
        marker: {
          enabled: true,
        },
        enableMouseTracking: true,
      },
      series: {
        animation: false,
        grouping: false,
        shadow: false,
        marker: {
          fillColor: colors.makerColor,
          radius: 3,
          lineWidth: 1,
          lineColor: colors.makerColor,
          states: {
            hover: {
              radius: 4.5,
            },
          },
        },
        color: colors.seriesColor,
        borderWidth: 0,
        pointWidth: 1,
        lineWidth: 2,
        states: {
          hover: {
            color: colors.pointHoverColor,
          },
        },
        point: { events: {} },
      },
    },
  };
}

function getBidlandscapeChartOptions(isClickGraph, i18n) {
  return getSlideChartOptions(isClickGraph, i18n);
}

function getMakerSetting(isCampaign) {
  const colors = isCampaign ? colorsCampaign : colorsDefault;
  return {
    marker: {
      enable: true,
      radius: 4.5,
      lineWidth: 1,
      lineColor: colors.makerColor,
      fillColor: colors.makerFillColor,
    },
    color: colors.markerPointColor,
  };
}

function getCampaignSlideChartOptions(clickGraph, i18n) {
  const options = getSlideChartOptions(clickGraph, i18n, colorsCampaign);

  options.tooltip = {
    shared: true,
    crosshairs: {
      enabled: true,
      color: colorsCampaign.crosshairsColor,
      dashStyle: 'longdash',
    },
    useHTML: true,
    headerFormat: '',
    pointFormat: '<div><b>{point.bidName}:{point.bid}</b></div>' +
      '<div>{point.name}: <b>{point.x}</b></div>' +
      '<div>{point.costName}: <b>{point.yStr}</div>',
    footerFormat: '',
    valueDecimals: 2,
  };
  options.title = {
    text: null,
    style: {
      color: colorsCampaign.labelColor,
      fontWeight: 'bold',
      fontSize: '12px',
    },
    align: 'left',
    margin: 15,
  };
  options.xAxis.title = {
    text: null,
    style: {
      color: colorsCampaign.labelColor,
      fontWeight: 'bold',
      fontSize: '12px',
    },
    margin: 10,
  };
  options.xAxis.labels.style = {
    color: colorsCampaign.labelColor,
    fontWeight: 'normal',
    fontSize: '12px',
  };
  options.yAxis.opposite = false;
  options.yAxis.labels.align = 'right';
  options.yAxis.labels.style = {
    color: colorsCampaign.labelColor,
    fontWeight: 'normal',
    fontSize: '12px',
  };
  return options;
}

export default {
  getCampaignSlideChartOptions,
  getBidlandscapeChartOptions,
  getMakerSetting,
  getAdgroupCurrentPointSetting,
};

